import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import MISDialog from '../MISDialog';
import './CreateFTP.css';
import {useDispatch, useSelector} from "react-redux";
import {contentAction, popupAction} from "../../../actions";
import TextInput from "../../input/TextInput";
import Select from "../../selectbox/Select"
import Checkbox from "../../checkbox/Checkbox";
import {contentService} from "../../../services";
import {toastr} from 'helper/toastrIntercept';
import {getMixString} from "../../../language/languageUtils";
import {validateSpecialChar,isNumber} from "../../../helper/contentValidator";

const CreateFTP = (props) => {
    const {t} = useTranslation();
    const myContentGroupId = useSelector(({content}) => content.myContentGroupId);
    const {id, content, editMode = false} = props;
    const dispatch = useDispatch();
    const pollingIntervalOption = [
        {title:1, value:1},
        {title:2, value:2},
        {title:3, value:3},
        {title:4, value:4},
        {title:5, value:5},
        {title:6, value:6},
        {title:7, value:7},
        {title:8, value:8},
        {title:9, value:9},
        {title:10, value:10},
        {title:15, value:15},
        {title:20, value:20},
        {title:25, value:25},
        {title:30, value:30}
    ];

    const remoteLoginRetryOption = [
        {title:1, value:1},
        {title:2, value:2},
        {title:3, value:3},
        {title:4, value:4},
        {title:5, value:5},
        {title:6, value:6}
    ];

    const [pollingInterval, setPollingInterval] = useState({
        interval : editMode ? content.ftpRefreshInterval : 1,
        disableInterval: editMode ? content.canRefresh === "N" : false
    });
    const [remoteLoginRetry, setRemoteLoginRetry] = useState({
        retryCount : editMode ? content.loginRetryMaxCount : 1,
        disableRetry: editMode ? content.canLoginRetry === "N" : false
    });

    const [ftpContent, setFtpContent] = useState({
        userId: localStorage.getItem('user').id,
        ftpContentName: editMode ? content.ftpContentName : '',
        ftpIP: editMode ? content.ftpIP : '',
        portStr: editMode ? content.portStr : '',
        ftpLoginId: editMode ? content.ftpLoginId : '',
        ftpPassword: editMode ? content.ftpPassword : '',
        ftpDirectory: editMode ? content.ftpDirectory : '',
        ftpRefreshInterval: editMode ? content.ftpRefreshInterval : 1,
        canRefresh:  editMode ? content.canRefresh : 'Y',
        loginRetryMaxCount: editMode ? content.loginRetryMaxCount : '1',
        canLoginRetry:  editMode ? content.canLoginRetry : 'Y'
    });

    const [errorText, setErrorText] = useState(undefined);

    const {interval, disableInterval} = pollingInterval;
    const {retryCount, disableRetry} = remoteLoginRetry;
    const {ftpContentName, ftpIP, portStr, ftpLoginId, ftpPassword, ftpRefreshInterval, ftpDirectory, loginRetryMaxCount} = ftpContent;

    const pollingEnable = useRef();
    const limitAttempts = useRef();


    const closePopup = () => {
        dispatch(popupAction.closePopup(id));
    };

    const togglePollingInterval = () => {
        if(pollingEnable.current.checked){
            limitAttempts.current.checked = true;
            setPollingInterval({...pollingInterval, disableInterval: false});
            setRemoteLoginRetry({...remoteLoginRetry, disableRetry: false});
            setFtpContent({...ftpContent, canRefresh: 'Y', canLoginRetry:'Y'});
        }else{
            setPollingInterval({...pollingInterval, disableInterval: true});
            setRemoteLoginRetry({...remoteLoginRetry, disableRetry: true});
            setFtpContent({...ftpContent, canRefresh: 'N', canLoginRetry:'N'});
            limitAttempts.current.checked = false;
        }
    };

    const onChangePollingInterval =(value) => {
        setPollingInterval({...pollingInterval, interval: value});
        setFtpContent({...ftpContent, ftpRefreshInterval: value});
    };

    const toggleLimitAttempts = () => {
        if(limitAttempts.current.checked){
            setRemoteLoginRetry({...remoteLoginRetry, disableRetry: false});
            setFtpContent({...ftpContent, canLoginRetry:'Y'});
        }else {
            setRemoteLoginRetry({...remoteLoginRetry, disableRetry: true});
            setFtpContent({...ftpContent, canLoginRetry:'N'});
        }
    };

    const onChangeLimitAttempts =(value) => {
        setRemoteLoginRetry({...remoteLoginRetry, retryCount:value});
        setFtpContent({...ftpContent, loginRetryMaxCount: value});
    };

    const saveFtpContent = () => {

        if(ftpContentName.trim() === '' || ftpIP.trim() === '' || ftpLoginId.trim() === '' || ftpPassword.trim() === '' || ftpDirectory.trim() === ''){
            toastr.error(t('MESSAGE_COMMON_ENTER_NECCESSARY_ITEM_P'));
        }else if(!validateSpecialChar(ftpContentName)) {
            toastr.error(t('COM_EBD_SPECIAL_CHAR_NOTALLOW_KR_2'));
        }else if(portStr.trim() !== '' && !isNumber(portStr)){
            setErrorText(t('COM_TV_SID_HOTEL_ONLY_NUMBERS_ARE_ALLOWED'));
        }else{
            setErrorText(undefined);
            let promise;
            if(editMode){
                const param = {
                    ...ftpContent,
                    portStr : portStr.trim() === '' ? "21" : portStr,
                    groupId : content.groupId
                };
                promise = contentService.editFtpSetting(content.contentId, param);
            }else {
                const param = {
                    ...ftpContent,
                    portStr : portStr.trim() === '' ? "21" : portStr,
                    groupId : myContentGroupId === "" ? 0 : myContentGroupId
                };
                promise = contentService.createFtpContent(param);
            }

            if(promise){
                promise.then(res => {
                    if(res.status === 'Success'){
                        toastr.success(t('MIS_TEXT_SUCCESS_SENT_P'));
                        dispatch(contentAction.reloadContent(true));
                        closePopup(id);
                    }
                }).catch(error => {
                    let errorMessage = error.errorMessage;
                    switch(error.errorCode){
                        case '400010':
                            errorMessage = t('MIS_SID_NO_CHANGES_HAVE_BEEN_MADE');
                            break;
                        case '403001':
                            errorMessage = t('ERROR_NO_ROLE');
                            break;
                        case '400308':
                            errorMessage = t('MIS_TEXT_CIFS_SERVER_ACCESS_FAILURE_P');
                            break;
                        case '400309':
                            errorMessage = t('MIS_TEXT_FTP_INVALID_FILES_P');
                            break;
                        case '400310':
                            errorMessage = t('MIS_TEXT_FTP_PARAM_INVALID_P');
                            break;
                        case '400311':
                            errorMessage = t('MIS_TEXT_CIFS_SERVER_LOGIN_FAILURE_P');
                            break;
                        case '400312':
                            errorMessage = t('MIS_TEXT_FTP_SAME_CONTENT_P');
                            break;
                        case '400313':
                            errorMessage = t('MIS_TEXT_FTP_INVALID_PATH_P');
                            break;
                        case '400314':
                            errorMessage = t('MESSAGE_SCHEDULE_ACCESS_DENIED_P');
                            break;
                    }
                    toastr.error(errorMessage);
                    closePopup(id);
                });
            }
        }
    };

    useEffect(() => {
        if(editMode){
            pollingEnable.current.checked = (content.canRefresh === 'Y');
            limitAttempts.current.checked = (content.canLoginRetry === 'Y');
        }else {
            pollingEnable.current.checked = true;
            limitAttempts.current.checked = true;
        }
    }, []);

    return (
        <div className='upload_ftp_content_popup_wrap'>
            <MISDialog dialog={{
                title: editMode ? t('MIS_TEXT_FTP_EDIT_FTP_P_KR_EDIT') : t('MIS_TEXT_FTP_ADD_FTP_P'),
                isDraggable: false,
                closeOnEscape: true,
                modal: true,
                width: 525,
                height: 383,
                position: {x: -150, y: -200},
                onClose: () => closePopup(),
            }}
                       buttons={{
                           rightButtons: [
                               {
                                   id: 'SAVE',
                                   title: t('COM_BUTTON_SAVE'),
                                   onClick: () => saveFtpContent(),
                               },
                               {
                                   id: 'CANCEL',
                                   title: t('BUTTON_CANCEL_P'),
                                   onClick: () => closePopup(),
                               }
                           ],
                       }}>
                <div className='upload_ftp_content_popup'>
                    <table>
                        <colgroup>
                            <col width="139px"/>
                            <col width=""/>
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>{t('TEXT_CONTENT_NAME_P')}</th>
                            <td>
                                <TextInput width={243} maxLength={100} placeholder={t('COM_IDS_ERR_CONTENTS_NAME')} value={ftpContentName}
                                           onChange={(e)=> setFtpContent({...ftpContent, ftpContentName:e.target.value})}/>
                            </td>
                        </tr>
                        <tr className="va_t">
                            <th>{t('MIS_TEXT_FTP_IP_ADDRESS_P')}</th>
                            <td>
                                <div id="remoteHostNameDiv">
                                    <TextInput width={243} placeholder={t('MIS_SID_ENTER_AN_IP_ADDRESS')} value={ftpIP}
                                               onChange={(e)=> setFtpContent({...ftpContent, ftpIP:e.target.value})}/>
                                </div>
                            </td>
                        </tr>
                        <tr></tr>
                        <tr>
                            <th>{t('COM_SETUP_NEW_STRING26_P')}</th>
                            <td className='port_td'>
                                <TextInput width={150} placeholder={"21"} maxLength={5} value={portStr}
                                           onChange={(e)=> setFtpContent({...ftpContent, portStr:e.target.value})} error={errorText}/>
                                &nbsp;&nbsp;&nbsp;<span>(Default:21)</span>
                            </td>
                        </tr>
                        <tr>
                            <th className='pt17'>{t('COM_TEXT_LOGIN_ID_P')}</th>
                            <td className='pt17'>
                                <TextInput width={243} placeholder={t('MESSAGE_USER_ENTER_USER_ID_P')} value={ftpLoginId}
                                           onChange={(e)=> setFtpContent({...ftpContent, ftpLoginId:e.target.value})}/>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('TEXT_PASSWORD_P')}</th>
                            <td>
                                <TextInput width={243} type={"password"} placeholder={t('COM_MESSAGE_USER_ENTER_PASS_P')} value={ftpPassword}
                                           onChange={(e)=> setFtpContent({...ftpContent, ftpPassword:e.target.value})}/>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('MIS_TEXT_FTP_REMOTE_DIR_P')}</th>
                            <td>
                                <TextInput width={243} maxLength={50} placeholder={t('MIS_SID_20_EXAMPLE_SHARED_FOLDER_NAME_OR')} value={ftpDirectory}
                                           onChange={(e)=> setFtpContent({...ftpContent, ftpDirectory:e.target.value})}/>
                                <br/>
                                <span>{t('MIS_SID_20_EXAMPLE_SHARED_FOLDER_NAME_OR')}</span>
                            </td>
                        </tr>
                        <tr>
                            <th className='pt25'>{t('MIS_TEXT_FTP_POLLING_INTERVAL_P')}</th>
                            <td className='pt25'>
                                <div className="select_box float_l mr8" id="remotePollingBox">
                                    <Select selects={pollingIntervalOption} width={100} value={interval}
                                            onChange={(e,value) =>onChangePollingInterval(value)} disabled={disableInterval}/>
                                </div>
                                <span className="space float_l mr8">{t('COM_SID_MIN')}</span>
                                <span className="space">
                                    <Checkbox id={"canRefresh"} name={t('TEXT_ENABLE2_P')} ref={pollingEnable} onChange={togglePollingInterval}/>
                                </span>

                            </td>
                        </tr>
                        <tr>
                            <th className='pt6'>{t('MIS_SID_RETRY_LOGIN')}</th>
                            <td className='pt6'>
                                <div className="select_box float_l mr8" id="remoteLoginRetryBox">
                                    <Select selects={remoteLoginRetryOption} width={100} value={retryCount}
                                            onChange={(e,value) => onChangeLimitAttempts(value)} disabled={disableRetry}/>
                                </div>
                                <span className="space float_l mr8">{t('MIS_SID_TIMS_S')}</span>
                                <span className="space">
                                    <Checkbox id={"canLoginRetry"} name={t('MIS_SID_LIMIT_ATTEMPTS')} ref={limitAttempts} onChange={toggleLimitAttempts}/>
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className='warring_text'>
                        {getMixString(['MIS_SID_MIX_CAFEB_IF_SPCIAL_CHAR_EXCLUD_DOWN', '\'<\', \'>\', \'&\''])}
                    </div>
                </div>
            </MISDialog>
        </div>
    );
};

export default CreateFTP;